import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    border: "1px solid rgba(18, 24, 38, 0.06)",
    overflow: "hidden",
  },
  content: {
    padding: theme.spacing(0),
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  metricRow: {
    borderBottom: "1px solid rgba(15, 23, 42, 0.06)",
    [theme.breakpoints.up("md")]: {
      borderBottom: 0,
      borderRight: "1px solid rgba(15, 23, 42, 0.06)",
    },
  },
  metric: {
    padding: theme.spacing(2, 2, 2, 2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  metricTitle: {
    color: "#7b8494",
    fontSize: 13,
    marginBottom: theme.spacing(1),
  },
  metricValue: {
    lineHeight: 1.6,
    fontWeight: 500,
  },
  metricSubtitle: {
    marginTop: theme.spacing(1),
    color: "#627084",
  },
  summaryWrap: {
    padding: theme.spacing(2),
  },
  summaryTitle: {
    marginBottom: theme.spacing(1),
    lineHeight: 1.4,
  },
  summaryValue: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  progressMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(1),
    color: "#6b7280",
  },
  progressBar: {
    marginTop: theme.spacing(2),
    height: 4,
    borderRadius: 999,
  },
}));

const parseNumber = (value) => {
  if (value === undefined || value === null) {
    return 0;
  }
  const parsed = Number(String(value).replace(/,/g, "").replace(/%/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
};

const getMetric = (kpis, key) => kpis.find((item) => item.key === key) || {};

const RegularSeasonKpiCards = ({ kpis }) => {
  const classes = useStyles();
  const uniqueShot = getMetric(kpis, "uniqueShot");
  const achievementRate = getMetric(kpis, "achievementRate");
  const reviewOk = getMetric(kpis, "reviewOk");
  const uniqueShooter = getMetric(kpis, "uniqueShooter");
  const firstShooter = getMetric(kpis, "firstShooter");

  const reviewOkValue = parseNumber(reviewOk.value);
  const achievementPercent = parseNumber(achievementRate.value);
  const targetMatch = String(achievementRate.subtitle || "").match(/対象\s*([0-9,]+)本/);
  const targetValue = targetMatch ? parseNumber(targetMatch[1]) : 0;
  const progressValue = Math.min(Math.max(achievementPercent, 0), 100);

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={10}>
            <Grid container spacing={0}>
              {[uniqueShot, achievementRate, reviewOk, uniqueShooter, firstShooter].map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={index < 4 ? 2 : 2}
                  key={item.key || index}
                  className={classes.metricRow}
                >
                  <Box className={classes.metric}>
                    <Typography variant="body2" className={classes.metricTitle}>
                      {item.title}
                    </Typography>
                    <Typography variant="h6" className={classes.metricValue}>
                      {item.value}
                    </Typography>
                    {item.subtitle ? (
                      <Typography variant="body1" className={classes.metricSubtitle}>
                        {item.subtitle}
                      </Typography>
                    ) : null}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
};

RegularSeasonKpiCards.propTypes = {
  kpis: PropTypes.array.isRequired,
};

export default RegularSeasonKpiCards;
